import {AppliedSheetSettings} from '@mintdata-wsp/common/controllers/spreadsheet/SheetSettingsController';
import {SlotFormula} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {NamedRangeId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {
    custom,
    list,
    object,
    optional,
    raw,
    serializable,
    serialize
} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

const valueModelSchema = custom(
    function(currentPropertyValue:IValue)
    {
        return serialize(currentPropertyValue);
    },
    function(jsonValue:any, context?, currentPropertyValue?)
    {
        return Type.deserializeIValue(jsonValue);
    }
);

const slotFormulaModelSchema = custom(
    function(currentPropertyValue:SlotFormula)
    {
        return typeof currentPropertyValue === 'string' ? currentPropertyValue : serialize(currentPropertyValue);
    },
    function(jsonValue:any, context?, currentPropertyValue?)
    {
        return typeof jsonValue === 'string' ? jsonValue : Type.deserializeIValue(jsonValue);
    }
);

export class MeshCopiedCell
{
    @serializable
    public colOffset:number;
    @serializable
    public rowOffset:number;
    @serializable(optional(valueModelSchema))
    public value:IValue;
    @serializable(optional(slotFormulaModelSchema))
    public formula:SlotFormula;
    @serializable(optional(object(SlotLocation)))
    public location:SlotLocation;
    @serializable
    public isLazySlot:boolean;

    @serializable(list(object(AppliedSheetSettings)))
    public sheetSettings:Array<AppliedSheetSettings>;

    @serializable
    public cellFormatId:string;

    @serializable(list(raw()))
    public namedRangeIds:Array<NamedRangeId>;

    public constructor(colOffset:number,
                       rowOffset:number,
                       value:IValue,
                       formula:SlotFormula,
                       location:SlotLocation,
                       sheetSettings:Array<AppliedSheetSettings>,
                       appliedFormat:string,
                       namedRangeIds:Array<NamedRangeId>,
                       isLazySlot:boolean)
    {
        this.colOffset = colOffset;
        this.rowOffset = rowOffset;
        this.value = value;
        this.formula = formula;
        this.location = location;
        this.sheetSettings = sheetSettings;
        this.cellFormatId = appliedFormat;
        this.namedRangeIds = namedRangeIds;
        this.isLazySlot = isLazySlot;
    }
}
